<template>
  <div
    class="modal fade bd-example-modal-lg"
    id="DetailKYC"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myLargeModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header bg-transparent border-0">
          <button
            type="button"
            class="btn-close"
            data-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body mx-3 text-base font-semibold greyscale-600">
          <div class="flex items-center justify-center mb-8">
            <div class="bg-grey-300 h-12 w-12 rounded-full flex items-center justify-center">
              <svg
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21.4982 1.35077C21.382 1.2568 21.2462 1.19006 21.1009 1.15546C20.9555 1.12085 20.8042 1.11926 20.6582 1.1508C20.2792 1.23522 19.8865 1.23694 19.5069 1.15584C19.1272 1.07474 18.7695 0.912728 18.4582 0.680854C18.2869 0.555721 18.0803 0.488281 17.8682 0.488281C17.656 0.488281 17.4494 0.555721 17.2782 0.680854C16.9668 0.912728 16.6091 1.07474 16.2294 1.15584C15.8498 1.23694 15.4571 1.23522 15.0782 1.1508C14.9321 1.11926 14.7808 1.12085 14.6355 1.15546C14.4901 1.19006 14.3543 1.2568 14.2382 1.35077C14.1221 1.44488 14.0287 1.56378 13.9647 1.69874C13.9006 1.83371 13.8677 1.9813 13.8682 2.13068V5.44027C13.8674 6.15727 14.0332 6.86466 14.3525 7.50667C14.6718 8.14867 15.1359 8.70774 15.7082 9.13981L17.2782 10.2997C17.4494 10.4248 17.656 10.4922 17.8682 10.4922C18.0803 10.4922 18.2869 10.4248 18.4582 10.2997L20.0282 9.13981C20.6004 8.70774 21.0645 8.14867 21.3838 7.50667C21.7031 6.86466 21.8689 6.15727 21.8682 5.44027V2.13068C21.8687 1.9813 21.8357 1.83371 21.7717 1.69874C21.7076 1.56378 21.6142 1.44488 21.4982 1.35077ZM19.8682 5.44027C19.8729 5.84194 19.7851 6.23931 19.6117 6.60167C19.4383 6.96402 19.1839 7.28166 18.8682 7.53001L17.8682 8.24992L16.8682 7.53001C16.5524 7.28166 16.298 6.96402 16.1246 6.60167C15.9512 6.23931 15.8635 5.84194 15.8682 5.44027V3.21054C16.5661 3.17795 17.2486 2.9937 17.8682 2.67061C18.4877 2.9937 19.1702 3.17795 19.8682 3.21054V5.44027ZM17.8682 12.4894C17.6029 12.4894 17.3486 12.5947 17.1611 12.7823C16.9735 12.9698 16.8682 13.2241 16.8682 13.4893V13.8792L15.3682 12.3994C15.1107 12.1403 14.8046 11.9347 14.4673 11.7944C14.1301 11.6541 13.7684 11.5819 13.4032 11.5819C13.0379 11.5819 12.6762 11.6541 12.339 11.7944C12.0018 11.9347 11.6956 12.1403 11.4382 12.3994L10.7382 13.0993L8.27816 10.6096C7.74828 10.1053 7.04473 9.82401 6.31316 9.82401C5.5816 9.82401 4.87805 10.1053 4.34816 10.6096L2.86816 12.0894V6.49014C2.86816 6.22495 2.97352 5.97063 3.16106 5.78312C3.34859 5.5956 3.60295 5.49026 3.86816 5.49026H10.8682C11.1334 5.49026 11.3877 5.38492 11.5753 5.1974C11.7628 5.00989 11.8682 4.75557 11.8682 4.49038C11.8682 4.2252 11.7628 3.97088 11.5753 3.78336C11.3877 3.59585 11.1334 3.49051 10.8682 3.49051H3.86816C3.07251 3.49051 2.30945 3.80654 1.74684 4.36908C1.18423 4.93162 0.868164 5.69458 0.868164 6.49014V18.4887C0.868164 19.2842 1.18423 20.0472 1.74684 20.6097C2.30945 21.1722 3.07251 21.4883 3.86816 21.4883H15.8682C16.6638 21.4883 17.4269 21.1722 17.9895 20.6097C18.5521 20.0472 18.8682 19.2842 18.8682 18.4887V13.4893C18.8682 13.2241 18.7628 12.9698 18.5753 12.7823C18.3877 12.5947 18.1334 12.4894 17.8682 12.4894ZM3.86816 19.4885C3.60295 19.4885 3.34859 19.3832 3.16106 19.1957C2.97352 19.0082 2.86816 18.7538 2.86816 18.4887V14.9191L5.76816 11.9895C5.91508 11.8495 6.11023 11.7714 6.31316 11.7714C6.5161 11.7714 6.71125 11.8495 6.85816 11.9895L10.0282 15.1591L14.3682 19.4885H3.86816ZM16.8682 18.4887C16.8598 18.6788 16.7974 18.8627 16.6882 19.0186L12.1782 14.5091L12.8782 13.8092C13.0243 13.6639 13.2221 13.5823 13.4282 13.5823C13.6343 13.5823 13.832 13.6639 13.9782 13.8092L16.8682 16.7089V18.4887Z"
                  fill="#20409B"
                />
              </svg>
            </div>
            <div class="ml-2 text-base font-semibold txt-grey-900">Chi tiết lịch KYC</div>
          </div>

          <div class="flex justify-between mb-4">
            <div class="flex">
              <div class="mr-4">
                <div class="mb-3">Chuyên gia Y Tế </div>
                <div>Lịch hẹn</div>
              </div>

              <div class="text-black">
                <div class="mb-3">{{ dataDetail &&  dataDetail.doctor.name}}</div>
                <div v-if="dataDetail && dataDetail.meeting_date" >{{`${getTime(dataDetail.meeting_start_time)} - ${getTime(dataDetail.meeting_end_time)}  (${getDay(dataDetail.meeting_date)})`}}</div>
              </div>
            </div>

            <div>
              <div v-if="dataDetail && dataDetail.cs_user" class="cursor-pointer" @click="handleJoinRoom"><svg
                  width="21"
                  height="21"
                  viewBox="0 0 21 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.5625 6.54036L8.39583 7.70703L10.5625 9.8737H2.0625V11.5404H10.5625L8.39583 13.707L9.5625 14.8737L13.7292 10.707L9.5625 6.54036ZM17.0625 16.5404H10.3958V18.207H17.0625C17.9792 18.207 18.7292 17.457 18.7292 16.5404V4.8737C18.7292 3.95703 17.9792 3.20703 17.0625 3.20703H10.3958V4.8737H17.0625V16.5404Z"
                    fill="#20419B"
                  />
                </svg>
                <span class="ml-2">Vào phòng</span>
              </div>
              <div v-else class="cursor-pointer" @click="handleAccept"><svg
                  width="21"
                  height="21"
                  viewBox="0 0 21 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.7637 11.3338H15.097C14.876 11.3338 14.664 11.4216 14.5077 11.5779C14.3515 11.7342 14.2637 11.9462 14.2637 12.1672C14.2637 12.3882 14.3515 12.6002 14.5077 12.7564C14.664 12.9127 14.876 13.0005 15.097 13.0005H15.8553C15.6817 14.0225 15.1946 14.9653 14.4615 15.6984C13.7285 16.4314 12.7857 16.9185 11.7637 17.0922V9.66718H12.597C12.818 9.66718 13.03 9.57938 13.1863 9.4231C13.3425 9.26682 13.4303 9.05486 13.4303 8.83385C13.4303 8.61283 13.3425 8.40087 13.1863 8.24459C13.03 8.08831 12.818 8.00051 12.597 8.00051H11.7637V7.01718C12.3197 6.8206 12.7883 6.43379 13.0867 5.92511C13.3851 5.41644 13.4941 4.81865 13.3943 4.2374C13.2946 3.65615 12.9926 3.12888 12.5417 2.74876C12.0908 2.36864 11.5201 2.16016 10.9303 2.16016C10.3406 2.16016 9.76985 2.36864 9.31896 2.74876C8.86806 3.12888 8.56607 3.65615 8.46634 4.2374C8.36662 4.81865 8.47558 5.41644 8.77398 5.92511C9.07238 6.43379 9.54099 6.8206 10.097 7.01718V8.00051H9.26367C9.04266 8.00051 8.8307 8.08831 8.67442 8.24459C8.51814 8.40087 8.43034 8.61283 8.43034 8.83385C8.43034 9.05486 8.51814 9.26682 8.67442 9.4231C8.8307 9.57938 9.04266 9.66718 9.26367 9.66718H10.097V17.0922C9.07497 16.9185 8.13219 16.4314 7.39914 15.6984C6.66609 14.9653 6.17902 14.0225 6.00534 13.0005H6.76367C6.98469 13.0005 7.19665 12.9127 7.35293 12.7564C7.50921 12.6002 7.59701 12.3882 7.59701 12.1672C7.59701 11.9462 7.50921 11.7342 7.35293 11.5779C7.19665 11.4216 6.98469 11.3338 6.76367 11.3338H5.09701C4.87599 11.3338 4.66403 11.4216 4.50775 11.5779C4.35147 11.7342 4.26367 11.9462 4.26367 12.1672C4.26367 13.9353 4.96605 15.631 6.21629 16.8812C7.46654 18.1315 9.16223 18.8338 10.9303 18.8338C12.6984 18.8338 14.3941 18.1315 15.6444 16.8812C16.8946 15.631 17.597 13.9353 17.597 12.1672C17.597 11.9462 17.5092 11.7342 17.3529 11.5779C17.1966 11.4216 16.9847 11.3338 16.7637 11.3338ZM10.9303 5.50051C10.7655 5.50051 10.6044 5.45164 10.4674 5.36007C10.3303 5.2685 10.2235 5.13835 10.1604 4.98608C10.0974 4.83381 10.0809 4.66625 10.113 4.5046C10.1452 4.34295 10.2245 4.19447 10.3411 4.07792C10.4576 3.96138 10.6061 3.88201 10.7678 3.84986C10.9294 3.8177 11.097 3.83421 11.2492 3.89728C11.4015 3.96035 11.5317 4.06716 11.6232 4.2042C11.7148 4.34124 11.7637 4.50236 11.7637 4.66718C11.7637 4.88819 11.6759 5.10015 11.5196 5.25643C11.3633 5.41271 11.1514 5.50051 10.9303 5.50051Z"
                    fill="#20419B"
                  />
                </svg>
                <span class="ml-2">Nhận phụ trách</span>
              </div>
            </div>
          </div>

          <div class="mb-3">
            <div class="mb-2.5">Kết luận</div>
            <input
              class="p-3 border-input font-medium txt-grey-500 h-22 rounded-1xl w-full focus:outline-none"
              placeholder="Nội dung này sẽ được điền vào phần giữa của nội dung Email kết quả KYC"
              v-model="public_note"
            />
          </div>

          <div class="mb-3">
            <div class="mb-2.5">Ghi chú nội bộ</div>
            <input
              class="p-3 border-input font-medium txt-grey-500 h-12 rounded-1xl w-full focus:outline-none"
              placeholder="Những chú ý cần chia sẻ nội bộ HODO"
              v-model="internal_note"
            />
          </div>

          <div class="mb-4">
            <div class="mb-2.5">Trạng thái Xác thực</div>
            <div class="flex items-center justify-between">
              <!-- <input
                class="p-3 border-input font-medium txt-grey-900 h-12 rounded-2xl w-full focus:outline-none"
                placeholder="Xác thực"
              /> -->
              <select
                v-model="statusKYC"
                class="
                  form-select
                  radius-16
                  border
                  bg-white
                  fs-16
                  fw-500
                  txt-grey-900
                "
              >
                <option :value="0">Chưa xác thực</option>
                <option :value="1">Đã xác thực</option>
                <option :value="2">Không được xác thực</option>
              </select>
              <div class="w-full text-right">
                <button
                  class="btn radius-0 bg-pri bd-pri text-white border-0"
                  @click="handleUpdate"
                > Cập nhật</button>
              </div>
            </div>
          </div>

          <div class="mb-2.5 grid grid-cols-2 gap-4">
            <div>Tài liệu</div>
            <div>Ngày upload</div>
          </div>

          <div v-if="dataDetail && dataDetail.certs">
            <div v-for="(cert, index) in dataDetail.certs" :key="index">
              <div v-if="cert.front_cert_url" class="p-2 mb-2 grid grid-cols-2 gap-4 txt-grey-900 text-sm font-semibold border-bottom border-grey-700" >
                <div><a :href="cert.front_cert_url" target="_blank">{{`Ảnh chụp ${cert.cert_type_code} (mặt trước)`}}</a></div>
                <div class="font-normal">{{getDay(cert.updated_at)}}</div>
              </div>
              <div v-if="cert.back_cert_url" class="p-2 mb-2 grid grid-cols-2 gap-4 txt-grey-900 text-sm font-semibold border-bottom border-grey-700" >
                <div><a :href="cert.back_cert_url" target="_blank">{{`Ảnh chụp ${cert.cert_type_code} (mặt sau)`}}</a></div>
                <div class="font-normal">{{getDay(cert.updated_at)}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import appUtils from '../../../utils/appUtils'
export default {
  name: 'DetailKYC',
  props: ['kycID'],
  data () {
    return {
      public_note: '',
      internal_note: '',
      dataDetail: null,
      statusKYC: -1
    }
  },
  computed: {
    adminRequest () {
      return this.$rf.getRequest('AdminRequest')
    }

  },
  watch: {
    kycID () {
      this.getKycDetail()
    }
  },
  methods: {
    getDay (item) {
      return window.moment(item).format('DD/MM/YYYY')
    },
    getTime (item) {
      return window.moment(item, 'HH:mm:ss').format('HH:mm')
    },
    async handleAccept () {
      if (!this.dataDetail) return
      const data = await this.adminRequest.putKycDetailJoin(this.kycID)
      this.dataDetail = {
        ...this.dataDetail,
        ...data.data
      }
      this.$emit('reload')
      window.$('#DetailKYC').modal('hide')
    },
    async getKycDetail () {
      if (!this.kycID) return
      const res = await this.adminRequest.getKycDetail(this.kycID)
      this.dataDetail = res.data
      this.statusKYC = this.dataDetail.status
      this.public_note = this.dataDetail.public_note
      this.internal_note = this.dataDetail.internal_note
    },
    handleJoinRoom () {
      let dm = ''
      if (process.env.NODE_ENV === 'development') {
        dm = 'https://dev.meet.hodo.com.vn/#/'
      } else {
        dm = 'https://meet.hodo.com.vn/#/'
      }
      let token = appUtils.getLocalToken()
      let routeData = dm + '_app/' + this.dataDetail.meet_room.room.room_name + '?token=' + token
      window.open(routeData, '_blank')
      window.$('#DetailKYC').modal('hide')
    },
    async updateKYC () {
      if (this.public_note === '' || this.internal_note === '') {
        alert('Kết luận và Ghi chú nội bộ không được để trống')
      }
      const params = {
        status: this.statusKYC,
        internal_note: this.internal_note,
        public_note: this.public_note
      }
      const data = await this.adminRequest.putKycDetailStatus(this.kycID, params)
      this.dataDetail = {
        ...this.dataDetail,
        ...data.data
      }
      this.$emit('reload')
      window.$('#DetailKYC').modal('hide')
    },
    handleUpdate () {
      this.updateKYC()
    }
  }
}
</script>

<style scoped>
.greyscale-600 {
  color: #718096;
}
.modal-header .btn-close {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='inherit'%3e%3cpath d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/%3e%3c/svg%3e");
}
.border-input {
  border: 1px solid #d1d6e0;
}
</style>